import React, { FC } from "react";
import styled from "styled-components";
import { commonUXTheme } from "styles/commonUXVariables";
import { NavItem } from "./NavItem";
import { MenuItemSelection } from "models/menuItemSelection";

interface ShoppingCartAreaProps {
  activePath?: string;
  useExternalLinks?: boolean;
  menuItem: MenuItemSelection[];
  itemsCount: number | null | undefined;
  baseUrl: string;
  onClickNavigationItem?: (internalRoute: string, externalRoute?: string | null) => void;
  translateText?: (text: string) => string;
  isMobile: boolean;
}

const Container = styled.div`
  position: relative;
  display: inline-block;
`;
const IconCountArea = styled.span`
  position: absolute;
  top: 15px;
  left: 30px ;
  border-radius: 10px;
  min-width: 20px;
  border: ${commonUXTheme.borders.widths.borderWidthS} ${commonUXTheme.colors.brandRed};
  padding-left: ${commonUXTheme.sizes.xs};
  padding-right: ${commonUXTheme.sizes.xs};
  background: ${commonUXTheme.colors.brandRed};
  font-size: ${commonUXTheme.fonts.sizes.fontSizeXs};
  color: ${commonUXTheme.colors.whitePrimary};
  text-align: center;
  cursor: pointer;
  pointer-events: none;
`;

export const IconArea: FC<ShoppingCartAreaProps> = ({
  activePath,
  useExternalLinks,
  menuItem,
  itemsCount,
  baseUrl,
  onClickNavigationItem,
  isMobile
}: ShoppingCartAreaProps) => {
  return (
    <>
      {menuItem.length > 0 ? (
        <Container>
          <NavItem
            isMobile={isMobile}
            onSelect={(internalRoute: string, externalRoute: string | null | undefined) => {
              onClickNavigationItem && onClickNavigationItem(internalRoute, externalRoute);
            }}
            activePath={activePath}
            baseUrl={baseUrl}
            useExternalLinks={useExternalLinks}
            menuItem={menuItem[0]}
          />
          {itemsCount && itemsCount > 0 ? (
            <IconCountArea>{itemsCount > 99 ? "99+" : itemsCount}</IconCountArea>
          ) : null}
        </Container>
      ) : null}
    </>
  );
};
